type AlbumSortOrder =
  | "modified_desc"
  | "created_desc"
  | "name_asc"
  | "name_desc"
  | "files_desc"
  | "files_asc"

const DEFAULT_ALBUM_SORT_ORDER: AlbumSortOrder = "created_desc"

export { DEFAULT_ALBUM_SORT_ORDER }
export type { AlbumSortOrder }
